export const Users= [
    {
        "id":1,
        "category":"Technology"

    },
    {
        "id":2,
        "category":"Entertainment"
    },
    {
        "id":3,
        "category":"Community"
    },
    {
        "id":4,
        "category":"Travel"
    },
    {
        "id":5,
        "category":"Food"
    },
    {
        "id":6,
        "category":"Games"
    },
    {
        "id":7,
        "category":"Internet",

    },
    {
        "id":8,
        "category":"Nature",

    },
    {
        "id":9,
        "category":"Life",
    },
    {
        "id":10,
        "category":"Social",

    }
    
]